import { campaignConfig } from "./campaign";
import styles from "./styles.scss";

/**
 * ログイン画面のキャンペーン表示エリア
 *
 * キャンペーン内容を変更する場合は、 campaign.ts を編集してください。
 */

const CampaignAside = () => {
  return (
    <aside
      className="mt-[-6.4rem] hidden grow bg-repeat text-center text-white md:block"
      style={{ backgroundImage: `url(${campaignConfig.backgroundImageUrl})` }}
    >
      <h3 className={styles.campaignAside__heading}>
        {campaignConfig.subHeading}
      </h3>
      <p className={styles.campaignAside__message}>
        {campaignConfig.asideMessage}
      </p>
      <a
        href={campaignConfig.linkUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={campaignConfig.imageUrl}
          alt="キャンペーン"
          className={`${styles.campaignAside__image} transform transition-transform hover:-translate-y-4`}
        />
      </a>
    </aside>
  );
};

export default CampaignAside;
